import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Team } from '@masar/common/models';
import { permissionList } from '@masar/common/constants';

@Component({
    selector: 'app-team-link',
    templateUrl: './team-link.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class TeamLinkComponent {
    @Input() public item: Team;
    public permissionList = permissionList;
}
